import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import SSOCallback from './pages/SSOCallback';
import Dashboard from './pages/Dashboard';
import TourList from './pages/TourList';
import TourDetail from './pages/TourDetail';
import NewTour from './pages/NewTour';
import AdminSettings from './pages/AdminSettings';
import EmailTemplates from './pages/EmailTemplates';
import EscalationChain from './pages/EscalationChain';
import Supplies from './pages/Supplies';
import FacilitySupplies from './pages/FacilitySupplies';
import ErrorBoundary from './components/ErrorBoundary';
import Reports from './pages/Reports';
import Help from './pages/Help';
import './App.css';

function PrivateRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner"/></div>;
  if (!user) return <Navigate to="/login" />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login />} />
      <Route path="/sso-callback" element={<SSOCallback />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Navigate to="/dashboard" />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="tours" element={<TourList />} />
        <Route path="tours/new" element={<PrivateRoute roles={['staff','regional_manager','executive_staff','super_admin']}><NewTour /></PrivateRoute>} />
        <Route path="tours/:id/edit" element={<PrivateRoute roles={['staff','regional_manager','executive_staff','super_admin']}><NewTour /></PrivateRoute>} />
        <Route path="tours/:id" element={<TourDetail />} />
        <Route path="supplies" element={<PrivateRoute roles={['staff','building_admin','regional_manager','executive_staff','super_admin']}><ErrorBoundary><Supplies /></ErrorBoundary></PrivateRoute>} />
        <Route path="facilities/:id/supplies" element={<PrivateRoute roles={['staff','building_admin','regional_manager','executive_staff','super_admin']}><ErrorBoundary><FacilitySupplies /></ErrorBoundary></PrivateRoute>} />
        <Route path="reports" element={<PrivateRoute roles={['building_admin','regional_manager','executive_staff','super_admin']}><ErrorBoundary><Reports /></ErrorBoundary></PrivateRoute>} />
        <Route path="help" element={<Help />} />
        <Route path="settings" element={<PrivateRoute roles={['super_admin']}><AdminSettings /></PrivateRoute>} />
        <Route path="email-templates" element={<PrivateRoute roles={['super_admin']}><EmailTemplates /></PrivateRoute>} />
        <Route path="escalation-chain" element={<PrivateRoute roles={['super_admin']}><EscalationChain /></PrivateRoute>} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
